const shuffle = (list) => {
  const array = list;
  // eslint-disable-next-line no-plusplus
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
};

export const getProjects = (amount = 'all') => {
  let response;
  const data = [
    {
      name: 'Estética Perruna',
      work: 'app.portfolio.card.work.logo',
      description: {
        en: 'Lorem Ipsum dolum ajsnkjan nakjsnkajsnd akjskajnd',
        es: 'Lorem Ipsum dolum ajsnkjan nakjsnkajsnd akjskajnd',
      },
      image: 'Estetica.png',
    },
    {
      name: 'Italian Collection',
      work: 'app.portfolio.card.work.project',
      description: {
        en: 'Lorem Ipsum dolum ajsnkjan nakjsnkajsnd akjskajnd',
        es: 'Lorem Ipsum dolum ajsnkjan nakjsnkajsnd akjskajnd',
      },
      image: 'Expo.png',
    },
    {
      name: 'Kings',
      work: 'app.portfolio.card.work.branding',
      description: {
        en: 'Lorem Ipsum dolum ajsnkjan nakjsnkajsnd akjskajnd',
        es: 'Lorem Ipsum dolum ajsnkjan nakjsnkajsnd akjskajnd',
      },
      image: 'Kings.png',
    },
    {
      name: 'Makeup Artist',
      work: 'app.portfolio.card.work.logo',
      description: {
        en: 'Lorem Ipsum dolum ajsnkjan nakjsnkajsnd akjskajnd',
        es: 'Lorem Ipsum dolum ajsnkjan nakjsnkajsnd akjskajnd',
      },
      image: 'MakeupArtist.png',
    },
    {
      name: 'Pizzeria',
      work: 'app.portfolio.card.work.branding',
      description: {
        en: 'Lorem Ipsum dolum ajsnkjan nakjsnkajsnd akjskajnd',
        es: 'Lorem Ipsum dolum ajsnkjan nakjsnkajsnd akjskajnd',
      },
      image: 'Pizzeria.png',
    },
    {
      name: 'Persal',
      work: 'app.portfolio.card.work.logo',
      description: {
        en: 'Lorem Ipsum dolum ajsnkjan nakjsnkajsnd akjskajnd',
        es: 'Lorem Ipsum dolum ajsnkjan nakjsnkajsnd akjskajnd',
      },
      image: 'Reposteria.png',
    },
    {
      name: 'Sofia Salazar',
      work: 'app.portfolio.card.work.logo',
      description: {
        en: 'Lorem Ipsum dolum ajsnkjan nakjsnkajsnd akjskajnd',
        es: 'Lorem Ipsum dolum ajsnkjan nakjsnkajsnd akjskajnd',
      },
      image: 'SofiaConfecciones.png',
    },
    {
      name: 'Vida Animal',
      work: 'app.portfolio.card.work.logo',
      description: {
        en: 'Lorem Ipsum dolum ajsnkjan nakjsnkajsnd akjskajnd',
        es: 'Lorem Ipsum dolum ajsnkjan nakjsnkajsnd akjskajnd',
      },
      image: 'VidaAnimal.png',
    },
  ];

  if (amount === 'all') {
    response = {
      data: shuffle(data),
    };
  } else {
    const random = [];
    do {
      // eslint-disable-next-line prefer-destructuring
      random[random.length] = data.splice(
        Math.floor(Math.random() * data.length),
        1,
      )[0];
    } while (random.length < amount);
    response = {
      data: random,
    };
  }
  return response;
};

export const sendMessage = (message) => message;
